import React from 'react';

const ModalStep1 = ({ onNext }) => {
    return (
        <div className="space-y-4">
            <div className='mb-6'>
                <p className='text-xl text-black text-justify'>Lengkapi identitas data diri anda dengan menekan tombol "Masuk" dibawah ini, untuk memastikan anda mendapatkan pelayanan terbaik dan informasi terbaru dari kami!</p>
            </div>
            <a href='https://ecsys.okoce.net/'>
                <button
                    type="button"
                    className="w-full text-white bg-[#e01f31] focus:ring-4 focus:outline-none focus:ring-[#1c75ac] font-medium rounded-lg text-sm px-5 py-2.5 text-center  hover:bg-red-700">
                    Masuk
                </button>
            </a>
            <button
                type="button"
                className="w-full text-white bg-[#1c75ac] hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-[#1c75ac] font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                onClick={onNext}
            >
                Lewati
            </button>
        </div>
    );
};

export default ModalStep1;
